import React from 'react';
type EyebrowProps = {
  children: React.ReactNode;
  tone?: 'light' | 'dark';
  className?: string;
};
export function Eyebrow({
  children,
  tone = 'dark',
  className = ''
}: EyebrowProps) {
  return <p className={`flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.28em] ${tone === 'light' ? 'text-brass-light' : 'text-brass-dark'} ${className}`} data-id="element-160" data-mp="1bw4j8xc53jd3">
      <span className={`h-px w-8 ${tone === 'light' ? 'bg-brass-light/60' : 'bg-brass/60'}`} aria-hidden="true" data-id="element-161" data-mp="11x5j635fww1p" />
      {children}
    </p>;
}